export function getDecompositionTreeNodeLabel({
  back,
  grapheme,
  mnemonicTerms,
}: {
  back?: string;
  grapheme: string;
  mnemonicTerms?: readonly string[];
}) {
  return mnemonicTerms?.find((term) => term.trim() !== "") ?? back ?? grapheme;
}
